export const environment = {
    production : true,
    apiUrl: 'https://api.agrify.ai/agrify-server/rest'
};